var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 51,
    viewBox: "0 0 120 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-900 -6549.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 -320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,1A131.46,131.46,0,0,0,36.822,2.988a88.516,88.516,0,0,0-18.857,5.4A39.324,39.324,0,0,0,5.424,16.28C2.488,19.229,1,22.331,1,25.5s1.488,6.271,4.424,9.22a39.324,39.324,0,0,0,12.541,7.891,88.516,88.516,0,0,0,18.857,5.4A131.46,131.46,0,0,0,60,50a131.46,131.46,0,0,0,23.178-1.988,88.516,88.516,0,0,0,18.857-5.4,39.324,39.324,0,0,0,12.541-7.891c2.935-2.95,4.424-6.052,4.424-9.22s-1.488-6.271-4.424-9.22a39.324,39.324,0,0,0-12.541-7.891,88.516,88.516,0,0,0-18.857-5.4A131.46,131.46,0,0,0,60,1m0-1c33.137,0,60,11.417,60,25.5S93.137,51,60,51,0,39.583,0,25.5,26.863,0,60,0Z",
    transform: "translate(874 6869.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(935.387 6560.335)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.415,0h3.568a11.349,11.349,0,0,0,2.225,4.526,6.215,6.215,0,0,0,5.018,2.681v3.6a9.584,9.584,0,0,1-7.208-3.3V19.821a9.009,9.009,0,1,1-9.009-9.009v3.6a5.406,5.406,0,1,0,5.406,5.406Z",
    transform: "translate(-12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.915-.5h4.477l.081.4A10.632,10.632,0,0,0,32.6,4.22a5.729,5.729,0,0,0,4.623,2.488h.5v4.6h-.5a9.924,9.924,0,0,1-6.708-2.6v11.11a9.509,9.509,0,1,1-9.509-9.509h.5v4.6h-.5a4.906,4.906,0,1,0,4.906,4.906Zm3.669,1H26.915V19.821a5.906,5.906,0,1,1-6.406-5.885v-2.61a8.509,8.509,0,1,0,9.009,8.495V6.23l.869.948a9.976,9.976,0,0,0,2.9,2.224,8.7,8.7,0,0,0,3.437.9V7.689a6.761,6.761,0,0,1-4.913-2.856A12.255,12.255,0,0,1,29.584.5Z",
    transform: "translate(-12)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.4a2140655eb5a1e5002ef02f3d689fbe.svg";
export { ForwardRef as ReactComponent };